<template>
  <div class="bigbox" >
      <img-app :style="backImg" :contactTitle="contact.name" :contactList="contact.contactlist" :pos="cur_pos"></img-app>
      <div class="main">
        <div class="EachDetail" >
          <div class="mainTitle ft16 lh-100 fontWeight">
            公司简介
          </div>
          <p class="lh-200">智慧职安环保科技有限公司（Smart H.S.E Technology Co.Ltd.）简称“智慧科技”，是一家致力于推动企业职业健康、安全生产和环境保护（以下简称HSE）和医疗机构放射卫生&辐射安全管理链信息化的互联网公司。公司核心技术团队在行业内从事了十几年的相关工作，具有丰富的理论和实践经验。同时，本公司也与多家行业内排名领先的管理咨询服务单位和机构保持了良好和深入的合作关系，拥有海量的专家资源支持。</p>
        </div>
        <div class="EachDetail" >
          <div class="mainTitle ft16 lh-100 fontWeight">
            公司文化
          </div>
          <p class="lh-200 pull-left">企业使命：拥抱互联网+，实现信息价值；<br>企业愿景：成为健康、安全和环保信息化垂直领域最有竞争力的服务提供商；<br>核心价值：诚信为本、客户至上、技术创新。</p>
          <img src="static/images/offical-culture.png" alt="" class="pull-right offical-culture absolute">
          <div class="clear"></div>
        </div>

        <div class="EachDetail" >
          <div class="mainTitle ft16 lh-100 fontWeight">
            荣誉资质
          </div>
          <div class="honor relative" @mouseenter="scrollMouse" @mouseleave="scrollMouse">
            <ul class="honorList relative" ref="main_node" :style="{left:`${move}px`,transition:transitionVal}">
              <li v-for="item in honorList" ><img :src="item.imgurl" alt=""></li>
            </ul>
            <button class="absolute left-btn"></button>
            <button class="absolute right-btn"></button>
          </div>
        </div>


        <div class="EachDetail" >
          <div class="mainTitle ft16 lh-100 fontWeight">
            联系我们
          </div>
          <p class="lh-200">联系电话：0571-89978771（或0571-89978775）<br><span>电子邮箱：smarthse@smarthse.cn</span><br>地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：浙江省·杭州市·江干区·水墩新路8号-5楼</p>
          <div class="mt32">
            <!-- <img src="static/images/address-map.png" alt="" class="pull-left"> -->
            <div class="pull-left map-contain" id="dituContent" style="height: 228px;width: 558px; display: block!important"></div>
            <div class="pull-right">
              
            </div>
            <div class="clear"></div>
            <div class=" lh-200 mt42">
              如果您：
              </div>
              <p class="lh-200">
                相信医疗机构放辐射管理和企业HSE管理链信息化服务具有巨大的潜力可挖掘；<br>拥有丰富的实践经验和凝聚协作的团队精神；<br>希望拥有执着，纯真的工作伙伴和开放的工作环境；<br>愿意与公司共同迎接竞争和挑战！
              </p>
              <div class="mt12 fontWeight">那么欢迎您加入我们，与公司一同成长吧！</div>
          </div>
        </div>
        <div class="h28"></div>
        
      </div>
    </div>
</template>

<script>
import imgApp from '@/components/common/imgApp.vue';
 import bus from '@/assets/js/bus'
export default {
  name: 'about',
  data () {
    return {
      backImg:{
        background:'url(static/images/about_us.jpg) no-repeat',
        backgroundSize:'cover'
      },
      //imgurl:'../../../static/images/offical-product.png'
      contact:{
        name:'关于我们',
        contactlist:[
            {listTitle:"公司简介"},
            {listTitle:"公司文化"},
            {listTitle:"荣誉资质"},
            {listTitle:"联系我们"},
        ]
      },
      honorList:[
        {imgurl:"static/images/honor_img1.jpg"},
        {imgurl:"static/images/honor_img2.jpg"},
        {imgurl:"static/images/honor_img3.jpg"},
        {imgurl:"static/images/honor_img4.jpg"},
        {imgurl:"static/images/honor_img5.jpg"},
        {imgurl:"static/images/honor_img6.jpg"}
      ],
      cur_pos:0,
      oData:[],
        move:0,//当前移动的距离
        width:180,//表示一个移动完需要的宽度
        time:2000,//表示完成移动玩一个item需要的时间，毫秒
        transitionVal:"none",//过渡的值
        id_timeout:null,
        
    }
  },
  methods:{
    //监听滚动距离
   changeHash(index){

      var EachDetail=$('.EachDetail');
      //获取需要滚动的距离
      let scrollHeight=EachDetail[index].offsetTop-200;
      //console.log(scrollHeight)
      //console.log($(document).scrollTop())

      //chrome
      /*document.body.scrollTop=scrollHeight;
      //firefox
      document.documentElement.scrollTop=scrollHeight;
      //safari
      window.pageYOffset=scrollHeight;*/
      //获取当前滚动条与顶部的距离
      let distance=document.documentElement.scrollTop||document.body.scrollTop;

      //计算每一小段的距离
      let step=scrollHeight/50;
      //屏幕向上滚动，内容由下至上
      if(distance<scrollHeight){
          smoothDown()
      }
      //屏幕向下滚动，内容由上至下
      else{
        let scrollDistance=distance-scrollHeight;
        step=scrollDistance/50;
        smoothUp();
      }
      function smoothDown(){
        if(distance<scrollHeight){
          distance+=step
          document.body.scrollTop=distance;
          document.documentElement.scrollTop=distance;
          setTimeout(smoothDown,5)
        }
        else{
          // 限制滚动停止时的距离
          document.body.scrollTop = scrollHeight
          document.documentElement.scrollTop = scrollHeight
        }
      }
      function smoothUp(){
        if (distance > scrollHeight) {
            distance -= step;
            document.body.scrollTop = distance;
            document.documentElement.scrollTop = distance;
            setTimeout(smoothUp, 10);
        } else {
            document.body.scrollTop = scrollHeight
            document.documentElement.scrollTop = scrollHeight
        }
      }
   },
   onScroll(){
    let scrolled = document.documentElement.scrollTop || document.body.scrollTop
    var EachDetail=$('.EachDetail');
    var arr=[];
    var mainTop=$('.main').offset().top;
      for(var i=0;i<EachDetail.length;i++){
          var topScroll=$(EachDetail[i]).position().top;
          if(mainTop!=434){
            topScroll-=68;
          }
          arr.push(topScroll);
      }
    //showAcitve(arr.length)
    //console.log(arr)//502, 704, 906, 1224     434  636  838  1156
    //console.log(scrolled)
    //console.log(scrolled<=434,434<scrolled && scrolled<=636,636<scrolled && scrolled<=838)
    if(scrolled<=arr[0]){
        bus.$emit('navChange',0);  
    }else if(arr[0]<scrolled && scrolled<=arr[1]){
      bus.$emit('navChange',1);
    }else if(arr[1]<scrolled && scrolled<=arr[2]){
      bus.$emit('navChange',2);
    }
    else{
      bus.$emit('navChange',3);
      
    }
   },
   //页面滚动，对应的标题样式改变
   /*showAcitve(arr){
    //当他的长度大于0
    if(length>0){
      if(arr[length-1]<scrolled<=arr[length]){
          bus.$emit('navChange',length);
      }
      length--;
      showAcitve(length)
    }
    else{

    }
   }*/
   imgscroll(paramTime){//滚动效果
      let num=this.honorList.length/2;//得到实际的数量
      let time;
      if(paramTime){
        time=paramTime;
      }
      else{
        time=this.time*num;
      }
      //console.log(num,time);
      this.transitionVal=`left ${time/1000}s linear`;
      //console.log(this.move)
      this.id_timeout=window.setTimeout(()=>{
          //console.log("开始动画")
          this.move=-this.width*num;
          //console.log(this.move)
          this.id_timeout=window.setTimeout(()=>{
            // console.log("调整");
             this.transitionVal=`none`;//瞬间完成节点转移
             this.move=0;
             this.id_timeout=window.setTimeout(()=>{
               // console.log("下一个动画");
                this.imgscroll();
              },10);
          },time);
      },0);
    },
    scrollMouse(e){
      if(e.type=="mouseenter"){
          var offsetLeft=this.$refs.main_node.offsetLeft;
          window.clearTimeout(this.id_timeout);
          this.transitionVal=`none`;
          this.move=offsetLeft;
      }
      else if(e.type=="mouseleave"){
        var offsetLeft=this.$refs.main_node.offsetLeft;//已经偏移的距离;此值为负数
        //console.log(offsetLeft)
        let num=this.honorList.length/2;//得到实际的数量
        var v=this.width/this.time;//得到速度
        var dValueS=num*this.width+offsetLeft;//剩余的路程
        var time=dValueS/v;//得到时间

        this.imgscroll(time);
      }
    },
    
    createMap(){
/*var map = new BMap.Map("allmap");*/
/*  var point = new BMap.Point(99,39.92556);*/
/*  map.centerAndZoom(point, 12);*/
/*  var marker = new BMap.Marker(point);  // 创建标注
  map.addOverlay(marker);              // 将标注添加到地图中
  marker.addEventListener("click",getAttr);
  function getAttr(){
    var p = marker.getPosition();       //获取marker的位置
    alert("marker的位置是" + p.lng + "," + p.lat);   
  }*/
        var map = new BMap.Map("dituContent");//在百度地图容器中创建一个地图
        var point = new BMap.Point(120.209768,30.313284);//定义一个中心点坐标
        /*document.getElementById('dituContent').style.display="";*/
        
        map.centerAndZoom(point,16);//设定地图的中心点和坐标并将地图显示在地图容器中
        //console.log($('#mask'))
        map.addEventListener('tilesloaded',function(){map.setCenter(point)})
        window.map = map;//将map变量存储在全局
        var marker = new BMap.Marker(point);  // 创建标注
        map.addOverlay(marker);              // 将标注添加到地图中
        //marker.addEventListener("click",this.getAttr);
    }
    
  },
  components:{
    "img-app":imgApp
  },
  created(){
    bus.$on('navHash',(index)=>{
      this.changeHash(index);
    });
    this.honorList=this.honorList.concat(this.honorList);
    this.imgscroll();
    
  },
  mounted: function () {
    this.$nextTick(function () {

      window.addEventListener('scroll', this.onScroll);
      //console.log($('#dituContent'))
      
     
    });
    
    //创建和初始化地图函数：
    function initMap(){
        createMap();//创建地图
        setMapEvent();//设置地图事件
        addMapControl();//向地图添加控件
        addMarker();//向地图中添加marker
    }
    
    //创建地图函数：
    function createMap(){  
        var map = new BMap.Map("dituContent");//在百度地图容器中创建一个地图
        var point = new BMap.Point(120.209768,30.313284);//定义一个中心点坐标
        //console.log(point)
        map.centerAndZoom(point,17);//设定地图的中心点和坐标并将地图显示在地图容器中
        
        window.map = map;//将map变量存储在全局
         var marker = new BMap.Marker(point);  // 创建标注
        map.addOverlay(marker);              // 将标注添加到地图中
    }
    
    //地图事件设置函数：
    function setMapEvent(){

        map.enableDragging();//启用地图拖拽事件，默认启用(可不写)
        map.enableScrollWheelZoom();//启用地图滚轮放大缩小
        map.enableDoubleClickZoom();//启用鼠标双击放大，默认启用(可不写)
        map.enableKeyboard();//启用键盘上下左右键移动地图
    }
    
    //地图控件添加函数：
    function addMapControl(){
        //向地图中添加缩放控件
  var ctrl_nav = new BMap.NavigationControl({anchor:BMAP_ANCHOR_TOP_LEFT,type:BMAP_NAVIGATION_CONTROL_LARGE});
  map.addControl(ctrl_nav);
                //向地图中添加比例尺控件
  var ctrl_sca = new BMap.ScaleControl({anchor:BMAP_ANCHOR_BOTTOM_LEFT});
  setTimeout(function(){
    map.addControl(ctrl_sca);
  },1000)
    }
    
    //标注点数组
    var markerArr = [{title:"        智慧职安环保科技有限公司",content:"浙江省·杭州市·江干区·水墩新路8号-5楼",point:"120.209768|30.313284",isOpen:1,icon:{w:23,h:25,l:46,t:21,x:9,lb:12}}
     ];  /*120.141647|30.298452*/
    //创建marker
    function addMarker(){
        for(var i=0;i<markerArr.length;i++){
            var json = markerArr[i];
            var p0 = json.point.split("|")[0];
            var p1 = json.point.split("|")[1];
            var point = new BMap.Point(p0,p1);
      var iconImg = createIcon(json.icon);
            var marker = new BMap.Marker(point,{icon:iconImg});
      var iw = createInfoWindow(i);
      var label = new BMap.Label(json.title,{"offset":new BMap.Size(json.icon.lb-json.icon.x+10,-20)});
      marker.setLabel(label);
            map.addOverlay(marker);
            label.setStyle({
                        borderColor:"#808080",
                        color:"#333",
                        cursor:"pointer"
            });
      
      (function(){
        var index = i;
        var _iw = createInfoWindow(i);
        var _marker = marker;
        _marker.addEventListener("click",function(){
            this.openInfoWindow(_iw);
          });
          _iw.addEventListener("open",function(){
            _marker.getLabel().hide();
          })
          _iw.addEventListener("close",function(){
            _marker.getLabel().show();
          })
        label.addEventListener("click",function(){
            _marker.openInfoWindow(_iw);
          })
        if(!!json.isOpen){
          label.hide();
          _marker.openInfoWindow(_iw);
        }
      })()
        }
    }
    //创建InfoWindow
    function createInfoWindow(i){
        var json = markerArr[i];
        var iw = new BMap.InfoWindow("<b class='iw_poi_title' title='" + json.title + "'>" + json.title + "</b><div class='iw_poi_content'>"+json.content+"</div>");
        return iw;
    }
    //创建一个Icon
    function createIcon(json){
        var icon = new BMap.Icon("http://app.baidu.com/map/images/us_mk_icon.png", new BMap.Size(json.w,json.h),{imageOffset: new BMap.Size(-json.l,-json.t),infoWindowOffset:new BMap.Size(json.lb+5,1),offset:new BMap.Size(json.x,json.h)})
        return icon;
    }
    
    initMap();//创建和初始化地图
  },
  destroyed(){
      window.removeEventListener('scroll', this.onScroll);
  }
  /*beforeRouteEnter (to, from, next) {
    // 在导航完成前获取数据,不刷新页面有效
    console.log(from.path)
  },*/
}  
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main{
  width: 1172px;
  margin:4px auto 0;
  padding-left: 200px;
}
.main .mainTitle{
   margin-top: 74px;
   padding-bottom: 28px;
   padding-left: 16px;
   background: url(../../static/images/current_title.png) no-repeat 2px 4px;
   color:#18191a;
} 
.offical-culture{
  margin-top: -62px;
}
.honor{
  width: 100%;
  overflow: hidden;
  min-width: 700px;
}
.honorList{
  width: 10000%;
  height: 200px;
}
.honorList li{
  width: 150px;
  height:100%;
  border:1px solid #d8e1e6;
  float: left;
  margin-right: 30px;
}
.honorList img{
  width: 148px;
  height: 198px;
}
.left-btn{
  left:0;
  top:80px;
}
.map-contain{
  width: 570px;
  height: 228px;
}
#dituContent{
  width: 570px;
  height: 228px;
}
/*.BMap_mask{height:570px;width: 228px;}*/
/* 关于我们自适应布局 */
@media (max-width: 1240px){
    .main{
      width: 100%;
      padding-left:24%;
      padding-right: 6%;
    }
    .offical-culture{
      width: 246px;
      margin-top: -25px;
    }
}
@media (max-width: 1168px){
  .main{
    padding-right: 4%;
  }
}
/* @media(max-width: 1010px){
  .offical-culture{
      width: 18%;
      margin-top: -18px;
    }
} */
</style>



// WEBPACK FOOTER //
// src/components/index-animate.vue